var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMfInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E6B532"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2832 10.5C29.0922 10.5 29.9967 11.7312 29.9967 13.142C29.9967 14.9037 28.4253 16.5331 26.3801 16.5331C24.6669 16.5331 23.6679 15.5207 23.7152 13.8467C23.7152 12.4386 24.9045 10.5 27.2832 10.5ZM21.7172 37.5C20.2889 37.5 19.2426 36.6198 20.2416 32.7426L21.8805 25.8684C22.1654 24.7695 22.2126 24.3281 21.8805 24.3281C21.4526 24.3281 19.6004 25.0868 18.5028 25.836L17.79 24.648C21.2622 21.6969 25.2569 19.9676 26.9714 19.9676C28.3983 19.9676 28.6359 21.6861 27.9231 24.3281L26.0453 31.5533C25.7132 32.829 25.8549 33.2691 26.1884 33.2691C26.6163 33.2691 28.0203 32.7399 29.4 31.6397L30.21 32.7386C26.8323 36.177 23.1428 37.5 21.7172 37.5Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfInfo);
export default __webpack_public_path__ + "static/media/mfInfo.94df0f8e4d0339ce047b5099454fae97.svg";
export { ForwardRef as ReactComponent };